var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container col-jj"},[_c('div',{staticClass:"intro about01_mod"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12 intro_text"},[_c('h4',[_vm._v(_vm._s(_vm.$t('about.OrangeConnex')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('about.OClimitedt'))),_c('br'),_vm._v(_vm._s(_vm.$t('about.OClimitedv')))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55139249","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/about/about01.vue
// module id = 762
// module chunks = 35